module.exports = __webpack_public_path__ + "static/media/blueprint.5cc1eee9.gif";